import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { useState } from 'react';

export type BirthdateInputProps = {
  value: string | null;
  onChange: (value: string | null) => void;
  label: string;
};

export function BirthdateInput({
  value,
  onChange,
  label,
}: BirthdateInputProps) {
  const [birthDate, setBirthDate] = useState(value ? dayjs(value) : null);

  const updateFormBirthDate = (newValue: dayjs.Dayjs | null) => {
    const newBirthDate = newValue?.isValid()
      ? newValue?.format('YYYY-MM-DD').split('T')[0]
      : null;

    if (newBirthDate === value) {
      return;
    }

    onChange(newBirthDate);
  };

  return (
    <DatePicker
      label={label}
      disableFuture
      openTo='year'
      views={['year', 'month', 'day']}
      value={birthDate}
      onChange={newValue => {
        setBirthDate(newValue);
        updateFormBirthDate(newValue);
      }}
      slotProps={{
        textField: {
          size: 'small',
          fullWidth: true,
          required: true,
        },
      }}
    />
  );
}
